import { c as _c } from "react/compiler-runtime";
import React from "react";
import styles from "./EffektButton.module.scss";
import Link from "next/link";
type ButtonType = "primary" | "secondary" | "tertiary";
const LinkButton: React.FC<{
  url: string;
  title: string;
  type?: ButtonType;
  squared?: boolean;
  target?: string;
  prefetch?: boolean;
}> = t0 => {
  const $ = _c(6);
  const {
    url,
    title,
    type: t1,
    squared,
    target,
    prefetch
  } = t0;
  const type = t1 === undefined ? "primary" : t1;
  const t2 = `${styles.button} ${type == "primary" ? styles.buttonprimary : type == "secondary" ? styles.buttonsecondary : type == "tertiary" ? styles.buttontertiary : styles.buttonprimary} ${squared ? styles.button__squared : null}`;
  const t3 = `${title}`;
  let t4;
  if ($[0] !== prefetch || $[1] !== t2 || $[2] !== t3 || $[3] !== target || $[4] !== url) {
    t4 = <Link href={url} target={target} prefetch={prefetch} className={t2}>{t3}</Link>;
    $[0] = prefetch;
    $[1] = t2;
    $[2] = t3;
    $[3] = target;
    $[4] = url;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  return t4;
};
export default LinkButton;